import React, { useEffect, useState } from 'react';

import { MAX_NOTE_NAME_LENGTH } from 'utils/constants';
import APModal from 'components/Modal/APModal';
import InputField from 'components/FormFields/InputField';
import APFormGroup from 'components/FormFields/APFormGroup';

const CreateFolderModal = ({ templateModalOpened, setTemplateModalOpened, createFolder }) => {
  const [templateName, setTemplateFolderName] = useState('');
  const [error, setError] = useState('');

  const fieldsCompleted = () => {
    return templateName;
  };

  useEffect(() => {
    if (fieldsCompleted() && error) {
      setError('');
    }
  }, [templateName]);

  const onCreate = () => {
    if (fieldsCompleted()) {
      createFolder({
        templateFolderName: templateName,
        position: 0,
      });
      setTemplateModalOpened(false);
    } else {
      setError('Please complete all required fields above.');
    }
  };

  const onCancel = () => {
    setTemplateModalOpened(false);
  };

  const folderNameOnChange = (event) => {
    setTemplateFolderName(event.target.value);
  };

  const modalActions = [{ onClick: onCreate, title: 'Create New' }];

  const modalContent = (
    <>
      <APFormGroup grid={false}>
        <InputField
          name="name_template"
          label="Folder Name"
          defaultValue={templateName}
          onChange={folderNameOnChange}
          onPointerDown={(e) => e.stopPropagation()}
          maxLength={MAX_NOTE_NAME_LENGTH}
          showError={!templateName && error}
          autoFocus
          required
        />
      </APFormGroup>
    </>
  );

  return renderModal(
    templateModalOpened,
    'Add a new folder.',
    'add-note-template-folder',
    modalActions,
    onCancel,
    modalContent,
    error,
  );
};

export default CreateFolderModal;

const renderModal = (
  modalOpened,
  title,
  name,
  modalActions,
  onClose,
  modalContent,
  error,
) => {

  const renderModalActions = () => {
    return (
      <>
        {modalActions.map((item, index) => (
          <button
            className="button"
            onClick={item.onClick}
            key={index}
          >
            {item.title}
          </button>
        ))}
      </>
    );
  };

  return (
    <APModal
      open={modalOpened}
      title={title}
      name={name}
      onClose={onClose}
      actions={renderModalActions()}
    >
      {modalContent}
      <section className='note-error'>
        {error}
      </section>
    </APModal>
  );
};
